/* Copyright 2013-2021 VMware, Inc. All rights reserved. -- VMware Confidential */
module platform {
   export class StatusFormatterService {
      static $inject = ["$injector"];
      // Not using type, because migrated service has different interface
      // (different method name)
      private _statusFormatterService: StatusFormatterService;

      private _defaultStatus: string = "entityStatus.gray";

      constructor(private $injector: any) {}

      get statusFormatterService(): StatusFormatterService {
         if (!this._statusFormatterService) {
            this._statusFormatterService = this.$injector.get("statusFormatterService");
         }
         return this._statusFormatterService;
      }

      format(status: string): any {
         return this._statusFormatterService.format(status);
      }
   }

   /**
    * @ngdoc service
    * @name com.vmware.platform.ui.StatusFormatterService
    * @module com.vmware.platform.ui
    *
    * @description
    *    Service for converting status strings to icon/label object
    *
    */
   angular.module('com.vmware.platform.ui')
         .service('statusFormatterService', StatusFormatterService);
}